import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import DPServices from "@dp/services";
import { action, computed, makeObservable, observable, reaction, runInAction } from "mobx";
import moment from "moment";
import { CartModel, ContactInfoModel, LocationModel } from ".";
import Base from "./Base";
import DineInOrderModel from "./models/DineInOrderModel";
import DineInConfirmationModel from "./models/DineInConfirmationModel";
import { formatPhoneNumber, handle, PlatformType } from "@dp/common";
import i18next from "i18next";
import { FETCH_TIME_TYPE } from "./MenuList";
var DineInOrder = (_class = /*#__PURE__*/function (_Base) {
  _inherits(DineInOrder, _Base);

  var _super = _createSuper(DineInOrder);

  function DineInOrder(rootStore) {
    var _this$rootStore8, _this$rootStore8$user;

    var _this;

    _classCallCheck(this, DineInOrder);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _defineProperty(_assertThisInitialized(_this), "dineInOrderModel", null);

    _defineProperty(_assertThisInitialized(_this), "cartModel", null);

    _defineProperty(_assertThisInitialized(_this), "dineInConfirmationModel", null);

    _defineProperty(_assertThisInitialized(_this), "appMessages", null);

    _defineProperty(_assertThisInitialized(_this), "contactInfoModel", null);

    _defineProperty(_assertThisInitialized(_this), "locationModel", null);

    _defineProperty(_assertThisInitialized(_this), "analyticsModel", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "cartOrder", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_restuarantDetails", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_sessionDetails", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_appAttributes", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "sessionAttributes", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_submitCount", _descriptor6, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "initiateDineInOrder", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(restID, id, source, kind, clearCart) {
        var initDineInOrderResponse, _this$rootStore, _this$rootStore$menuL, _this$rootStore2, _this$rootStore2$menu, _this$rootStore2$menu2, _this$rootStore2$menu3, _this$rootStore3, _this$rootStore3$menu, _this$rootStore4, _this$rootStore4$user, startTime, errorMessage;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return DPServices.DineInOrder.initiateDineInOrder(restID, id, source, kind, clearCart);

              case 3:
                initDineInOrderResponse = _context.sent;

                if (!(initDineInOrderResponse.status === "success")) {
                  _context.next = 13;
                  break;
                }

                _context.next = 7;
                return (_this$rootStore = _this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$menuL = _this$rootStore.menuList) === null || _this$rootStore$menuL === void 0 ? void 0 : _this$rootStore$menuL.fetchTimes(null, null, FETCH_TIME_TYPE.DINE_IN_FLOW, null, restID);

              case 7:
                // getting first slot
                startTime = (_this$rootStore2 = _this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$menu = _this$rootStore2.menuList) === null || _this$rootStore2$menu === void 0 ? void 0 : (_this$rootStore2$menu2 = _this$rootStore2$menu.timeModel) === null || _this$rootStore2$menu2 === void 0 ? void 0 : (_this$rootStore2$menu3 = _this$rootStore2$menu2.availableSlots[0]) === null || _this$rootStore2$menu3 === void 0 ? void 0 : _this$rootStore2$menu3.startTimeInMs; // set Restaurant and first time slot

                _context.next = 10;
                return (_this$rootStore3 = _this.rootStore) === null || _this$rootStore3 === void 0 ? void 0 : (_this$rootStore3$menu = _this$rootStore3.menuList) === null || _this$rootStore3$menu === void 0 ? void 0 : _this$rootStore3$menu.setOrderPickupTimeAndLocation(moment(startTime).toDate(), restID, "orderAhead");

              case 10:
                _context.next = 12;
                return (_this$rootStore4 = _this.rootStore) === null || _this$rootStore4 === void 0 ? void 0 : (_this$rootStore4$user = _this$rootStore4.user) === null || _this$rootStore4$user === void 0 ? void 0 : _this$rootStore4$user.updateSession();

              case 12:
                return _context.abrupt("return");

              case 13:
                _context.next = 21;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](0);
                _context.next = 19;
                return _this.parseError(_context.t0);

              case 19:
                errorMessage = _context.sent;

                _this.appMessages.showError(errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.title, errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.message, errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.additionalMessages, errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.options);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 15]]);
      }));

      return function (_x, _x2, _x3, _x4, _x5) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "dineInToPickupSwitch", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$rootStore5, _this$rootStore5$menu, _this$dineInOrderMode, _this$rootStore6, _this$rootStore7, _this$rootStore7$plat;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (_this$rootStore5 = _this.rootStore) === null || _this$rootStore5 === void 0 ? void 0 : (_this$rootStore5$menu = _this$rootStore5.menuList) === null || _this$rootStore5$menu === void 0 ? void 0 : _this$rootStore5$menu.clearCart();

            case 3:
              (_this$dineInOrderMode = _this.dineInOrderModel) === null || _this$dineInOrderMode === void 0 ? void 0 : _this$dineInOrderMode.setSwitchFromDineInMessageVisibility(false);
              _context2.next = 6;
              return (_this$rootStore6 = _this.rootStore) === null || _this$rootStore6 === void 0 ? void 0 : _this$rootStore6.user.updateSession();

            case 6:
              /**
               * cannot directly refresh page as if URL still has param it will init
               * Order Ahead again. redirectToURL() will perform navigation
               * with page refresh
               */
              (_this$rootStore7 = _this.rootStore) === null || _this$rootStore7 === void 0 ? void 0 : (_this$rootStore7$plat = _this$rootStore7.platformUtil) === null || _this$rootStore7$plat === void 0 ? void 0 : _this$rootStore7$plat.redirectToURL("/menu");
              _context2.next = 13;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);

              _this.dineInOrderModel.setSwitchFromDineInMessageVisibility(false);

              _this.appMessages.showError("Something went wrong", "Dinein to pickup switch failed");

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    })));

    _this.rootStore = rootStore;
    _this.dineInOrderModel = new DineInOrderModel(_this.rootStore.platformUtil);
    _this.dineInConfirmationModel = new DineInConfirmationModel(_this.rootStore.platformUtil);
    _this.appMessages = rootStore.appMessages;
    _this.cartModel = new CartModel(_this.rootStore.platformUtil);
    _this.contactInfoModel = new ContactInfoModel(_this.rootStore.platformUtil);
    _this.locationModel = new LocationModel();
    _this.analyticsModel = (_this$rootStore8 = _this.rootStore) === null || _this$rootStore8 === void 0 ? void 0 : (_this$rootStore8$user = _this$rootStore8.user) === null || _this$rootStore8$user === void 0 ? void 0 : _this$rootStore8$user.analyticsModel;
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DineInOrder, [{
    key: "_processSessionDetails",
    value: function _processSessionDetails(session) {
      var _this2 = this;

      runInAction(function () {
        var _session$successRespo;

        _this2._sessionDetails = session;

        _this2.dineInOrderModel.setSessionDetailsData(session);

        _this2.dineInConfirmationModel.setSessionDetailsData(session);

        _this2.locationModel.locationDateTime.actualPickupDateTime = (_session$successRespo = session.successResponse.sessionContext) === null || _session$successRespo === void 0 ? void 0 : _session$successRespo.actualPickupDateTime;
        _this2.locationModel.sessionDetails = session;
      });
    }
  }, {
    key: "_processAppAttributes",
    value: function () {
      var _processAppAttributes2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(appAttributes) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this._appAttributes = appAttributes;
                this.dineInOrderModel.setAppAttributesData(appAttributes);
                this.dineInConfirmationModel.setAppAttributesData(appAttributes);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _processAppAttributes(_x6) {
        return _processAppAttributes2.apply(this, arguments);
      }

      return _processAppAttributes;
    }()
  }, {
    key: "_processUserProfile",
    value: function _processUserProfile(isLoggedIn, userProfile) {
      //for pay at restaurant
      this.contactInfoModel.phoneNumberVisible = true;

      if (isLoggedIn && userProfile) {
        var _userProfile$defaultP;

        this.contactInfoModel.fName = userProfile.firstName;
        this.contactInfoModel.lName = userProfile.lastName;
        this.contactInfoModel.emailId = userProfile.login;
        var defaultPhoneNumber = (_userProfile$defaultP = userProfile.defaultPhone) === null || _userProfile$defaultP === void 0 ? void 0 : _userProfile$defaultP.phone;
        this.contactInfoModel.phoneNumber = formatPhoneNumber(defaultPhoneNumber);
      }
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return handle(this.rootStore.platformUtil.hydrateUsingSessionStorage(["ORDER_LEVEL_INSTRUCTIONS"].join("-"), this.dineInOrderModel));

              case 2:
                this._processSessionDetails(this.rootStore.user.sessionDetails);

                this._processAppAttributes(this.rootStore.common.appAttributes);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", Promise.resolve());

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", Promise.resolve());

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "logoutReset",
    value: function () {
      var _logoutReset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", Promise.resolve());

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function logoutReset() {
        return _logoutReset.apply(this, arguments);
      }

      return logoutReset;
    }()
  }, {
    key: "setupReactions",
    value: function setupReactions() {
      var _this3 = this; //app-init


      reaction(function () {
        return {
          appAttributes: _this3.rootStore.common.appAttributes
        };
      }, function (data) {
        _this3._processAppAttributes(data.appAttributes);
      }); //session-details

      reaction(function () {
        return {
          sessionDetails: _this3.rootStore.user.sessionDetails
        };
      }, /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(data) {
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _this3._processSessionDetails(data.sessionDetails);

                case 1:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        return function (_x7) {
          return _ref3.apply(this, arguments);
        };
      }()); // restuarant details

      reaction(function () {
        var _this3$rootStore, _this3$rootStore$rest;

        return {
          detail: (_this3$rootStore = _this3.rootStore) === null || _this3$rootStore === void 0 ? void 0 : (_this3$rootStore$rest = _this3$rootStore.restaurant) === null || _this3$rootStore$rest === void 0 ? void 0 : _this3$rootStore$rest.detail
        };
      }, /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(data) {
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _this3._restuarantDetails = data === null || data === void 0 ? void 0 : data.detail;

                  _this3.dineInOrderModel.setRestaurantDetailData(data === null || data === void 0 ? void 0 : data.detail);

                  _this3.dineInConfirmationModel.setRestaurantDetailData(data === null || data === void 0 ? void 0 : data.detail);

                case 3:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        }));

        return function (_x8) {
          return _ref4.apply(this, arguments);
        };
      }()); //user-profile

      reaction(function () {
        return {
          userProfile: _this3.rootStore.user.userProfile,
          isLoggedIn: _this3.rootStore.user.isLoggedIn
        };
      }, function (data) {
        if (data.isLoggedIn) {
          _this3._processUserProfile(data.isLoggedIn, data.userProfile);
        }
      });
    }
  }, {
    key: "parseError",
    value: function () {
      var _parseError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(e) {
        var _faults$faults,
            _this4 = this;

        var faults, firstFault, faultCode, faultDescription;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                faults = DPServices.Cart.parseErrors(e);
                firstFault = (faults === null || faults === void 0 ? void 0 : (_faults$faults = faults.faults) === null || _faults$faults === void 0 ? void 0 : _faults$faults.length) > 0 ? faults === null || faults === void 0 ? void 0 : faults.faults[0] : {};
                faultCode = firstFault === null || firstFault === void 0 ? void 0 : firstFault.faultCode;
                faultDescription = firstFault === null || firstFault === void 0 ? void 0 : firstFault.faultDescription;

                if (!(faultCode === "sessionExpired")) {
                  _context10.next = 8;
                  break;
                }

                return _context10.abrupt("return", {
                  title: "SessionExpired",
                  message: "Your session has expired due to an extended period of inactivity.",
                  additionalMessages: null,
                  options: {
                    undismissible: true,
                    okBtnText: "Ok",
                    okBtnOnClick: function okBtnOnClick() {
                      _this4.redirectToEmptyCartPage();
                    }
                  }
                });

              case 8:
                if (!(faultCode === "ORDER_AHEAD_NOT_AVAILABLE")) {
                  _context10.next = 12;
                  break;
                }

                return _context10.abrupt("return", {
                  title: "Order Ahead Not Available",
                  message: "Pre ordering for dine-in is not available at this location",
                  additionalMessages: null,
                  options: {
                    undismissible: true,
                    okBtnText: "Ok",
                    okBtnOnClick: function okBtnOnClick() {
                      if (_this4.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB) {
                        var _this4$rootStore;

                        (_this4$rootStore = _this4.rootStore) === null || _this4$rootStore === void 0 ? void 0 : _this4$rootStore.platformUtil.navigateToRoute("/home");
                      }
                    }
                  }
                });

              case 12:
                if (!(faultCode === undefined || faultDescription === undefined)) {
                  _context10.next = 14;
                  break;
                }

                return _context10.abrupt("return", {
                  title: i18next.t("error.dipo.init.failed.title", {
                    defaultValue: "Something went wrong"
                  }),
                  message: i18next.t("error.dipo.init.failed.message", {
                    defaultValue: "Please click the button below to reload the page."
                  }),
                  additionalMessages: null,
                  options: {
                    undismissible: true,
                    okBtnText: "Ok",
                    okBtnOnClick: function okBtnOnClick() {
                      if (_this4.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB) {
                        var _this4$rootStore2;

                        (_this4$rootStore2 = _this4.rootStore) === null || _this4$rootStore2 === void 0 ? void 0 : _this4$rootStore2.platformUtil.refreshPage();
                      }
                    }
                  }
                });

              case 14:
                return _context10.abrupt("return", {
                  title: faultCode,
                  message: faultDescription,
                  additionalMessages: null,
                  options: {
                    undismissible: true,
                    okBtnText: "Ok",
                    okBtnOnClick: function okBtnOnClick() {
                      if (_this4.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB) {
                        var _this4$rootStore3;

                        (_this4$rootStore3 = _this4.rootStore) === null || _this4$rootStore3 === void 0 ? void 0 : _this4$rootStore3.platformUtil.navigateToRoute("/home");
                      }
                    }
                  }
                });

              case 15:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function parseError(_x9) {
        return _parseError.apply(this, arguments);
      }

      return parseError;
    }()
  }, {
    key: "redirectToMenuPage",
    value: function () {
      var _redirectToMenuPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                this.rootStore.refreshInProgress = true;
                this.rootStore.platformUtil.redirectToURL("/menu");

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function redirectToMenuPage() {
        return _redirectToMenuPage.apply(this, arguments);
      }

      return redirectToMenuPage;
    }()
  }, {
    key: "getLastOrderData",
    value: function () {
      var _getLastOrderData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var lastOrder, _lastOrder$order;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return DPServices.Confirmation.getLastOrder();

              case 2:
                lastOrder = _context12.sent;

                if (!(lastOrder && Object.keys(lastOrder).length > 0)) {
                  _context12.next = 8;
                  break;
                }

                this.cartOrder = lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.order;
                this.dineInConfirmationModel.setLastOrderData(lastOrder);
                this.setCartItems(lastOrder === null || lastOrder === void 0 ? void 0 : (_lastOrder$order = lastOrder.order) === null || _lastOrder$order === void 0 ? void 0 : _lastOrder$order.commerceItems);
                return _context12.abrupt("return");

              case 8:
                this.redirectToMenuPage();

              case 9:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getLastOrderData() {
        return _getLastOrderData.apply(this, arguments);
      }

      return getLastOrderData;
    }()
  }, {
    key: "setCartItems",
    value: function () {
      var _setCartItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(commerceItems) {
        var cartItems;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                cartItems = this.cartModel.getCartItemsFromCommerceItems(commerceItems);
                this.dineInConfirmationModel.setCartItems(cartItems);

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function setCartItems(_x10) {
        return _setCartItems.apply(this, arguments);
      }

      return setCartItems;
    }()
  }, {
    key: "initDineInCheckout",
    value: function () {
      var _initDineInCheckout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var _this$rootStore9,
            _this$rootStore9$user,
            _this$rootStore10,
            _this$rootStore10$use,
            _this5 = this;

        var _yield$handle, _yield$handle2, err, sessionAttributes, _yield$handle3, _yield$handle4, cartDetailsErr, cartDetailsResponse;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                this.dineInOrderModel.isCheckoutPageLoading = true;
                _context15.next = 3;
                return handle(this.rootStore.platformUtil.hydrateUsingLocalStorage("CHECKOUT_CONTACT_INFO", this.contactInfoModel));

              case 3:
                this._processUserProfile((_this$rootStore9 = this.rootStore) === null || _this$rootStore9 === void 0 ? void 0 : (_this$rootStore9$user = _this$rootStore9.user) === null || _this$rootStore9$user === void 0 ? void 0 : _this$rootStore9$user.isLoggedIn, (_this$rootStore10 = this.rootStore) === null || _this$rootStore10 === void 0 ? void 0 : (_this$rootStore10$use = _this$rootStore10.user) === null || _this$rootStore10$use === void 0 ? void 0 : _this$rootStore10$use.userProfile); //sessioninit api


                _context15.next = 6;
                return handle(DPServices.Common.getSessionAttributes());

              case 6:
                _yield$handle = _context15.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                err = _yield$handle2[0];
                sessionAttributes = _yield$handle2[1];

                if (err) {
                  this.appMessages.showError("Checkout", "Invalid State. Please Go Back.", null, {
                    undismissible: true,
                    okBtnText: "Go Back",
                    okBtnOnClick: function okBtnOnClick() {
                      _this5.redirectToEmptyCartPage();
                    }
                  });
                } else {
                  if (sessionAttributes) {
                    runInAction(function () {
                      if (!(sessionAttributes !== null && sessionAttributes !== void 0 && sessionAttributes.dardenSessionContext.checkCreated)) {
                        _this5.redirectToEmptyCartPage();
                      } else {
                        _this5.sessionAttributes = sessionAttributes;
                      }
                    });
                  }
                } // getCartDetails


                _context15.next = 13;
                return handle(DPServices.Cart.getCartDetails());

              case 13:
                _yield$handle3 = _context15.sent;
                _yield$handle4 = _slicedToArray(_yield$handle3, 2);
                cartDetailsErr = _yield$handle4[0];
                cartDetailsResponse = _yield$handle4[1];

                if (cartDetailsErr) {
                  this.appMessages.showError("Cart", "Invalid State. Please Go Back.", null, {
                    undismissible: true,
                    okBtnText: "Go Back",
                    okBtnOnClick: function okBtnOnClick() {
                      _this5.redirectToEmptyCartPage();
                    }
                  });
                } else {
                  runInAction( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
                    var _cartDetailsResponse$;

                    var order;
                    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                      while (1) {
                        switch (_context14.prev = _context14.next) {
                          case 0:
                            order = cartDetailsResponse === null || cartDetailsResponse === void 0 ? void 0 : (_cartDetailsResponse$ = cartDetailsResponse.successResponse) === null || _cartDetailsResponse$ === void 0 ? void 0 : _cartDetailsResponse$.order;

                            if (order) {
                              _this5._processCartResponse(order);
                            }

                          case 2:
                          case "end":
                            return _context14.stop();
                        }
                      }
                    }, _callee14);
                  })));
                }

                this.dineInOrderModel.isCheckoutPageLoading = false;

              case 19:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function initDineInCheckout() {
        return _initDineInCheckout.apply(this, arguments);
      }

      return initDineInCheckout;
    }()
  }, {
    key: "redirectToEmptyCartPage",
    value: function redirectToEmptyCartPage() {
      if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB) {
        var _this$sessionAttribut;

        if ((_this$sessionAttribut = this.sessionAttributes) !== null && _this$sessionAttribut !== void 0 && _this$sessionAttribut.cartEmptyURL) {
          this.rootStore.refreshInProgress = true;
          this.rootStore.platformUtil.redirectToURL(this.sessionAttributes.cartEmptyURL);
        } else {
          this.rootStore.refreshInProgress = true;
          this.rootStore.platformUtil.redirectToURL("/order-online?cartEmpty=true");
        }
      } else {
        this.rootStore.reloadApp();
      }
    }
  }, {
    key: "_processCartResponse",
    value: function () {
      var _processCartResponse2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(order) {
        var restaurantId, _latLngArr$, _latLngArr$2, restaurantDetail, address, restPhoneNumber, restaurantName, phoneNumber, latLngArr, zipValue, location;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (!order) {
                  _context16.next = 14;
                  break;
                }

                this.cartOrder = order;
                restaurantId = order === null || order === void 0 ? void 0 : order.restaurantId;

                if (!restaurantId) {
                  _context16.next = 14;
                  break;
                }

                _context16.next = 6;
                return DPServices.Restaurant.getRestaurantDetailsById(restaurantId);

              case 6:
                restaurantDetail = _context16.sent;
                address = restaurantDetail.address, restPhoneNumber = restaurantDetail.restPhoneNumber, restaurantName = restaurantDetail.restaurantName;
                phoneNumber = restPhoneNumber[0]; //not safe

                latLngArr = address.longitudeLatitude ? address.longitudeLatitude.split(",") : [];
                zipValue = address.zipCode ? address.zipCode.substring(0, 5) : null;
                location = {
                  restaurantName: restaurantName,
                  address1: address.address1,
                  address2: address.address2,
                  city: address.city,
                  state: address.state,
                  zip: zipValue,
                  phoneNumber: formatPhoneNumber(phoneNumber.Phone),
                  lat: latLngArr && latLngArr.length > 1 ? (_latLngArr$ = latLngArr[0]) === null || _latLngArr$ === void 0 ? void 0 : _latLngArr$.trim() : null,
                  lng: latLngArr && latLngArr.length > 1 ? (_latLngArr$2 = latLngArr[1]) === null || _latLngArr$2 === void 0 ? void 0 : _latLngArr$2.trim() : null
                };
                this.locationModel.location = location;

                if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP) {
                  this.dineInOrderModel.setRestaurantDetailData(restaurantDetail);
                  this.dineInConfirmationModel.setRestaurantDetailData(restaurantDetail);
                }

              case 14:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function _processCartResponse(_x11) {
        return _processCartResponse2.apply(this, arguments);
      }

      return _processCartResponse;
    }()
  }, {
    key: "submitOrder",
    value: function () {
      var _submitOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var _this6 = this;

        var _this$contactInfoMode, _this$dineInOrderMode2, _this$_appAttributes, _this$_appAttributes$, _this$dineInOrderMode3, _this$contactInfoMode2, _this$contactInfoMode3, _this$contactInfoMode4, _this$contactInfoMode5, _this$contactInfoMode6, emailSignupSource, submitOrderRequest, errorMessage;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;

                if ((_this$contactInfoMode = this.contactInfoModel) !== null && _this$contactInfoMode !== void 0 && _this$contactInfoMode.isContactInfoValid) {
                  _context17.next = 4;
                  break;
                }

                this.appMessages.showError("Missing Details", "Please enter all highlighted fields.", null, {
                  okBtnText: "OK",
                  okBtnOnClick: function okBtnOnClick() {
                    var _this6$contactInfoMod;

                    _this6._submitCount = _this6.submitCount + 1;
                    var componentRef = (_this6$contactInfoMod = _this6.contactInfoModel) === null || _this6$contactInfoMod === void 0 ? void 0 : _this6$contactInfoMod.componentRef;
                    setTimeout(function () {
                      var _componentRef$current;

                      componentRef === null || componentRef === void 0 ? void 0 : (_componentRef$current = componentRef.current) === null || _componentRef$current === void 0 ? void 0 : _componentRef$current.scrollIntoView({
                        behavior: "smooth"
                      });
                    }, 150);
                  }
                });
                return _context17.abrupt("return");

              case 4:
                this.dineInOrderModel.isOrderSubmitting = true;
                emailSignupSource = (_this$dineInOrderMode2 = this.dineInOrderModel) !== null && _this$dineInOrderMode2 !== void 0 && _this$dineInOrderMode2.splOffer ? (_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : (_this$_appAttributes$ = _this$_appAttributes.configs) === null || _this$_appAttributes$ === void 0 ? void 0 : _this$_appAttributes$.dineinorder_crm_signup_source : null;
                submitOrderRequest = {
                  brandOptin: (_this$dineInOrderMode3 = this.dineInOrderModel) === null || _this$dineInOrderMode3 === void 0 ? void 0 : _this$dineInOrderMode3.splOffer,
                  emailSignupSource: emailSignupSource,
                  // dineinorder_crm_signup_source
                  emailId: (_this$contactInfoMode2 = this.contactInfoModel) === null || _this$contactInfoMode2 === void 0 ? void 0 : _this$contactInfoMode2.emailId,
                  instructions: this.dineInOrderModel.specialInstructions,
                  firstName: (_this$contactInfoMode3 = this.contactInfoModel) === null || _this$contactInfoMode3 === void 0 ? void 0 : _this$contactInfoMode3.fName,
                  lastName: (_this$contactInfoMode4 = this.contactInfoModel) === null || _this$contactInfoMode4 === void 0 ? void 0 : _this$contactInfoMode4.lName,
                  phoneNumber: (_this$contactInfoMode5 = this.contactInfoModel) === null || _this$contactInfoMode5 === void 0 ? void 0 : _this$contactInfoMode5.phoneNumber,
                  locale: "en_US",
                  confirmEmailId: (_this$contactInfoMode6 = this.contactInfoModel) === null || _this$contactInfoMode6 === void 0 ? void 0 : _this$contactInfoMode6.emailId,
                  paymentCollection: {
                    "atg-rest-class-type": "java.util.ArrayList",
                    "atg-rest-class-descriptor": {
                      "atg-rest-values": {
                        "container-class": "java.util.ArrayList",
                        "element-class": "com.darden.integration.paymentservice.bean.TransactionalDetail"
                      }
                    },
                    "atg-rest-values": [{
                      // TODO: confirm about correct fields to map
                      inStorePayment: {
                        "atg-rest-class-type": "com.darden.commerce.order.purchase.InStorePaymentBean",
                        amount: this.cartOrder.priceInfo.amount,
                        tipAmount: 0
                      }
                    }]
                  }
                };
                _context17.next = 9;
                return DPServices.Cart.submitDineInOrder(this.cartOrder.orderId, submitOrderRequest);

              case 9:
                this.dineInOrderModel.isOrderSubmitting = false;

                if (!(this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP)) {
                  _context17.next = 13;
                  break;
                }

                _context17.next = 13;
                return this.rootStore.user.updateSession();

              case 13:
                this.redirectToConfirmationPage();
                _context17.next = 23;
                break;

              case 16:
                _context17.prev = 16;
                _context17.t0 = _context17["catch"](0);
                this.dineInOrderModel.isOrderSubmitting = false;
                _context17.next = 21;
                return this.parseSubmitError(_context17.t0);

              case 21:
                errorMessage = _context17.sent;
                this.appMessages.showError(errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.title, errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.message, errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.additionalMessages, errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.options);

              case 23:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[0, 16]]);
      }));

      function submitOrder() {
        return _submitOrder.apply(this, arguments);
      }

      return submitOrder;
    }()
  }, {
    key: "parseSubmitError",
    value: function () {
      var _parseSubmitError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(e) {
        var _faults$faults2,
            _this7 = this;

        var faults, firstFault, faultCode, faultDescription;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                faults = DPServices.Cart.parseErrors(e);
                firstFault = (faults === null || faults === void 0 ? void 0 : (_faults$faults2 = faults.faults) === null || _faults$faults2 === void 0 ? void 0 : _faults$faults2.length) > 0 ? faults === null || faults === void 0 ? void 0 : faults.faults[0] : {};
                faultCode = firstFault === null || firstFault === void 0 ? void 0 : firstFault.faultCode;
                faultDescription = firstFault === null || firstFault === void 0 ? void 0 : firstFault.faultDescription;

                if (!(faultCode === "sessionExpired")) {
                  _context18.next = 8;
                  break;
                }

                return _context18.abrupt("return", {
                  title: "SessionExpired",
                  message: "Your session has expired due to an extended period of inactivity.",
                  additionalMessages: null,
                  options: {
                    undismissible: true,
                    okBtnText: "Ok",
                    okBtnOnClick: function okBtnOnClick() {
                      _this7.redirectToEmptyCartPage();
                    }
                  }
                });

              case 8:
                if (!(faultCode === undefined || faultDescription === undefined)) {
                  _context18.next = 10;
                  break;
                }

                return _context18.abrupt("return", {
                  title: "Order Submit Failed",
                  message: "Try Again"
                });

              case 10:
                return _context18.abrupt("return", {
                  title: faultCode,
                  message: faultDescription
                });

              case 11:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      function parseSubmitError(_x12) {
        return _parseSubmitError.apply(this, arguments);
      }

      return parseSubmitError;
    }()
  }, {
    key: "redirectToConfirmationPage",
    value: function redirectToConfirmationPage() {
      var _this8 = this;

      this.rootStore.refreshInProgress = true;
      this.rootStore.platformUtil.clearSessionStorage()["finally"](function () {
        if (_this8.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP) {
          var _this8$rootStore, _this8$rootStore$plat;

          (_this8$rootStore = _this8.rootStore) === null || _this8$rootStore === void 0 ? void 0 : (_this8$rootStore$plat = _this8$rootStore.platformUtil) === null || _this8$rootStore$plat === void 0 ? void 0 : _this8$rootStore$plat.navigateToRoute("/order-ahead/confirmation/");
          _this8.rootStore.refreshInProgress = false;
        } else {
          _this8.rootStore.platformUtil.redirectToURL("/order-ahead/confirmation/");
        }
      });
    }
  }, {
    key: "setJoinEClub",
    value: function () {
      var _setJoinEClub = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(email, signupSource) {
        var secondarySubscriptions,
            eClubStep,
            res,
            _this$rootStore11,
            _this$rootStore11$app,
            _this$rootStore12,
            _this$rootStore12$app,
            _args19 = arguments;

        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                secondarySubscriptions = _args19.length > 2 && _args19[2] !== undefined ? _args19[2] : [];
                eClubStep = _args19.length > 3 && _args19[3] !== undefined ? _args19[3] : "1";
                _context19.next = 4;
                return DPServices.Confirmation.setJoinEClub(email, signupSource, secondarySubscriptions, eClubStep);

              case 4:
                res = _context19.sent;

                if (res !== null && res !== void 0 && res.guestAlreadySubscribed) {
                  (_this$rootStore11 = this.rootStore) === null || _this$rootStore11 === void 0 ? void 0 : (_this$rootStore11$app = _this$rootStore11.appMessages) === null || _this$rootStore11$app === void 0 ? void 0 : _this$rootStore11$app.showError("Error", "You are already subscribed to the eClub.");
                } else {
                  // analytics code
                  this.orderConfirmEClubEvent(secondarySubscriptions, signupSource);
                  (_this$rootStore12 = this.rootStore) === null || _this$rootStore12 === void 0 ? void 0 : (_this$rootStore12$app = _this$rootStore12.appMessages) === null || _this$rootStore12$app === void 0 ? void 0 : _this$rootStore12$app.showError("Success", "You have been subscribed to the eClub.");
                }

                return _context19.abrupt("return", res);

              case 7:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function setJoinEClub(_x13, _x14) {
        return _setJoinEClub.apply(this, arguments);
      }

      return setJoinEClub;
    }()
  }, {
    key: "orderConfirmEClubEvent",
    value: function () {
      var _orderConfirmEClubEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(brands, signupChannel) {
        var brandValForEvents;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                if (brands && brands.length > 0) {
                  brandValForEvents = brands.map(function (el) {
                    switch (el) {
                      case "general-olive-garden-logo":
                        return "OG";

                      case "general-longhorn-logo":
                        return "LH";

                      case "general-cheddars-logo":
                        return "CSK";

                      case "general-seasons-logo":
                        return "S52";

                      case "general-bahama-breeze-logo":
                        return "BB";

                      case "general-yard-house-logo":
                        return "YH";

                      case "general-eddie-vs-logo":
                        return "EV";

                      case "general-the-capital-grill-logo":
                        return "TCG";

                      case "general-the-capital-burger-logo":
                        return "TCB";

                      default:
                        return el;
                    }
                  });
                  this.analyticsModel.dispatchEClubOrderConfirmation(brandValForEvents, signupChannel);
                }

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function orderConfirmEClubEvent(_x15, _x16) {
        return _orderConfirmEClubEvent.apply(this, arguments);
      }

      return orderConfirmEClubEvent;
    }()
  }, {
    key: "createAccount",
    value: function () {
      var _createAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(args) {
        var res, _args$dobYear, _this$_sessionDetails, _this$_sessionDetails2, _this$_sessionDetails3, _this$_sessionDetails4, _this$_sessionDetails5, _this$_sessionDetails6, _this$rootStore$platf, _this$rootStore13, _this$rootStore13$app, _res$data;

        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return DPServices.Confirmation.createAccount(args);

              case 2:
                res = _context21.sent;

                if (res.success) {
                  // analytics code
                  this.accountCreationEvent(null, null, "US", args === null || args === void 0 ? void 0 : (_args$dobYear = args.dobYear) === null || _args$dobYear === void 0 ? void 0 : _args$dobYear.toString(), this === null || this === void 0 ? void 0 : (_this$_sessionDetails = this._sessionDetails) === null || _this$_sessionDetails === void 0 ? void 0 : (_this$_sessionDetails2 = _this$_sessionDetails.successResponse) === null || _this$_sessionDetails2 === void 0 ? void 0 : (_this$_sessionDetails3 = _this$_sessionDetails2.restaurantDetails) === null || _this$_sessionDetails3 === void 0 ? void 0 : _this$_sessionDetails3.restaurantId, this === null || this === void 0 ? void 0 : (_this$_sessionDetails4 = this._sessionDetails) === null || _this$_sessionDetails4 === void 0 ? void 0 : (_this$_sessionDetails5 = _this$_sessionDetails4.successResponse) === null || _this$_sessionDetails5 === void 0 ? void 0 : (_this$_sessionDetails6 = _this$_sessionDetails5.restaurantDetails) === null || _this$_sessionDetails6 === void 0 ? void 0 : _this$_sessionDetails6.restaurantNumber);
                  (_this$rootStore$platf = this.rootStore.platformUtil) === null || _this$rootStore$platf === void 0 ? void 0 : _this$rootStore$platf.redirectToURL("/customer-service/recent-activity");
                } else {
                  (_this$rootStore13 = this.rootStore) === null || _this$rootStore13 === void 0 ? void 0 : (_this$rootStore13$app = _this$rootStore13.appMessages) === null || _this$rootStore13$app === void 0 ? void 0 : _this$rootStore13$app.showError("Error", "A user already exists with the login ".concat(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.login));
                }

                return _context21.abrupt("return", res);

              case 5:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function createAccount(_x17) {
        return _createAccount.apply(this, arguments);
      }

      return createAccount;
    }()
  }, {
    key: "accountCreationEvent",
    value: function () {
      var _accountCreationEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(zipCode, state, country, birthYear, restId, restNum) {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                this.analyticsModel.dispatchOrderConfirmationAccCreat(zipCode, state, country, birthYear, restId, restNum);

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function accountCreationEvent(_x18, _x19, _x20, _x21, _x22, _x23) {
        return _accountCreationEvent.apply(this, arguments);
      }

      return accountCreationEvent;
    }()
  }, {
    key: "cartItemTotalQuantity",
    value: function cartItemTotalQuantity(items) {
      var total = 0;
      items === null || items === void 0 ? void 0 : items.forEach(function (_c) {
        total = total + (_c === null || _c === void 0 ? void 0 : _c.quantity);
      });
      return total;
    }
  }, {
    key: "itemsForCartDetails",
    get: function get() {
      var _this$cartModel, _this$cartOrder;

      return (_this$cartModel = this.cartModel) === null || _this$cartModel === void 0 ? void 0 : _this$cartModel.getCartItemsFromCommerceItems((_this$cartOrder = this.cartOrder) === null || _this$cartOrder === void 0 ? void 0 : _this$cartOrder.commerceItems);
    }
  }, {
    key: "submitCount",
    get: function get() {
      return this._submitCount;
    }
  }, {
    key: "cartItemsCount",
    get: function get() {
      var _this$cartOrder2;

      return this.cartItemTotalQuantity((_this$cartOrder2 = this.cartOrder) === null || _this$cartOrder2 === void 0 ? void 0 : _this$cartOrder2.commerceItems);
    }
  }]);

  return DineInOrder;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "cartOrder", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_restuarantDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sessionAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_submitCount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, "submitOrder", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submitOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "itemsForCartDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "itemsForCartDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submitCount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "submitCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cartItemsCount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cartItemsCount"), _class.prototype)), _class);
export { DineInOrder as default };